var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "flex-column" },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "tiers",
            label: _vm.$t.__("common.labels.third_account")
          }
        },
        [
          _c("el-autocomplete", {
            attrs: { "fetch-suggestions": _vm.tiersCodeSuggestions },
            model: {
              value: _vm.tiersCode,
              callback: function($$v) {
                _vm.tiersCode = $$v
              },
              expression: "tiersCode"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.$store.state.individual.details.type === "supplier"
        ? _c(
            "el-form-item",
            {
              attrs: {
                prop: "purchase",
                label: _vm.$t.__(
                  "thirds.thirdscomponents.FormFieldsIndividualsAccountability.charge_account"
                )
              }
            },
            [
              _c("el-autocomplete", {
                attrs: { "fetch-suggestions": _vm.purchaseCodeSuggestions },
                model: {
                  value: _vm.purchaseCode,
                  callback: function($$v) {
                    _vm.purchaseCode = $$v
                  },
                  expression: "purchaseCode"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            prop: "auxiliary",
            label: _vm.$t.__(
              "thirds.thirdscomponents.FormFieldsIndividualsAccountability.auxiliary_account_code"
            )
          }
        },
        [
          _c("el-input", {
            attrs: { autocomplete: "off" },
            model: {
              value: _vm.auxiliaryCode,
              callback: function($$v) {
                _vm.auxiliaryCode = $$v
              },
              expression: "auxiliaryCode"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }